var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hostess-income-rank-base", style: _vm.cssVars() },
    [
      _c("div", { staticClass: "hostess-income-rank-bg" }, [
        _c(
          "div",
          {
            staticClass: "custom-nav-block",
            style: `padding-top:${_vm.barHeight}px`,
          },
          [
            _c("van-nav-bar", {
              staticClass: "van-bar",
              attrs: { "left-arrow": "" },
              on: { "click-left": _vm.closeWeb },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/arrow01.png"),
                          alt: "",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "tit-right",
                          on: { click: _vm.handleToRule },
                        },
                        [
                          _c("img", {
                            staticClass: "left-nav",
                            attrs: {
                              src: require("@/assets/packageAssets/common/rules01.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
        _c("div", { staticClass: "switch-tab" }, [
          _c(
            "div",
            {
              staticClass: "tab-item",
              class: { "tab-on": _vm.dateType === "day" },
              on: {
                click: function ($event) {
                  return _vm.handleDate("day")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.commonM.k456")))]
          ),
          _c(
            "div",
            {
              staticClass: "tab-item",
              class: { "tab-on": _vm.dateType === "week" },
              on: {
                click: function ($event) {
                  return _vm.handleDate("week")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.commonM.k457")))]
          ),
        ]),
        _c("div", { staticClass: "select-tab" }, [
          _c(
            "div",
            {
              staticClass: "tab-item",
              class: { "tab-on": _vm.costType === "income" },
              on: {
                click: function ($event) {
                  return _vm.handleCost("income")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.dl.income")))]
          ),
          _c(
            "div",
            {
              staticClass: "tab-item",
              class: { "tab-on": _vm.costType === "gift" },
              on: {
                click: function ($event) {
                  return _vm.handleCost("gift")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.mybean.gift")))]
          ),
        ]),
        _c("div", { staticClass: "hostess-income-rank-bar" }, [
          _c("div", { staticClass: "prize" }, [
            _c("div", { staticClass: "two" }, [
              _c("div", { staticClass: "rank_c2_avatar" }, [
                _vm.prize2.avatar
                  ? _c("img", {
                      attrs: {
                        src: _vm._f("imgPath")(_vm.prize2.avatar),
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "rank-sort" }),
              _c("div", { staticClass: "item-num" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.prize2.nickname)),
                ]),
                _c("span", { staticClass: "num" }, [
                  _vm._v(" " + _vm._s(_vm.prize2.score) + " "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.prize2.score,
                        expression: "prize2.score",
                      },
                    ],
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "one" }, [
              _c("div", { staticClass: "rank_c1_avatar" }, [
                _vm.prize1.avatar
                  ? _c("img", {
                      attrs: {
                        src: _vm._f("imgPath")(_vm.prize1.avatar),
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "rank-sort" }),
              _c("div", { staticClass: "item-num" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.prize1.nickname)),
                ]),
                _c("span", { staticClass: "num" }, [
                  _vm._v(" " + _vm._s(_vm.prize1.score) + " "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.prize1.score,
                        expression: "prize1.score",
                      },
                    ],
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "three" }, [
              _c("div", { staticClass: "rank_c3_avatar" }, [
                _vm.prize3.avatar
                  ? _c("img", {
                      attrs: {
                        src: _vm._f("imgPath")(_vm.prize3.avatar),
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "rank-sort" }),
              _c("div", { staticClass: "item-num" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.prize3.nickname)),
                ]),
                _c("span", { staticClass: "num" }, [
                  _vm._v(" " + _vm._s(_vm.prize3.score) + " "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.prize3.score,
                        expression: "prize3.score",
                      },
                    ],
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "hostess-income-rank-con" }, [
          _c(
            "div",
            { staticClass: "rank-body" },
            [
              _c("div", { staticClass: "date-limit" }, [
                _c("div", { staticClass: "timename" }, [
                  _vm._v(_vm._s(_vm.$t("lang.kissGf.ranking"))),
                ]),
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm.startTime) + " ~ " + _vm._s(_vm.endTime)),
                ]),
              ]),
              _vm.rankList && _vm.rankList.length > 0
                ? _vm._l(_vm.rankList, function (item) {
                    return _c("div", { key: item, staticClass: "agent-item" }, [
                      item.rank
                        ? _c("span", { staticClass: "rank-num" }, [
                            _vm._v(_vm._s(item.rank)),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "avatar rank-avatar" }, [
                        item.avatar
                          ? _c("img", {
                              attrs: {
                                src: _vm._f("imgPath")(item.avatar),
                                alt: "",
                              },
                            })
                          : _vm._e(),
                        _c("span", [_vm._v(_vm._s(item.nickname))]),
                      ]),
                      _c("div", { staticClass: "item-num" }, [
                        _vm._v(" " + _vm._s(item.score) + " "),
                        _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                      ]),
                    ])
                  })
                : _c("div", { staticClass: "rank-nodata" }, [
                    _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k169")) + " "),
                  ]),
            ],
            2
          ),
          _c("div", { staticClass: "owner-item" }, [
            _c("div", { staticClass: "owner-item-content" }, [
              _c("div", { staticClass: "avatar" }, [
                _vm.owners.rank && _vm.owners.rank > 0
                  ? _c("span", { staticClass: "rank-num" }, [
                      _vm._v(_vm._s(_vm.owners.rank)),
                    ])
                  : _c("span", { staticClass: "rank-num" }, [_vm._v("--")]),
                _c("div", { staticClass: "avatar-box" }, [
                  _vm.owners.avatar
                    ? _c("img", {
                        attrs: {
                          src: _vm._f("imgPath")(_vm.owners.avatar),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _c("div", [
                    _c("span", { staticClass: "owner-nickname" }, [
                      _vm._v(_vm._s(_vm.owners.nickname)),
                    ]),
                    !_vm.owners.rank || !(_vm.owners.rank > 0)
                      ? _c("span", { staticClass: "owner-rank" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k169"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "item-num" }, [
                _vm._v(" " + _vm._s(_vm.owners.score || 0) + " "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", {
              staticStyle: { width: "100%" },
              style: { height: `${_vm.bottomBarHeight}px` },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }